import React from 'react'
import { List } from 'antd'
import { ProviderPriceCalculationQuery } from '../graphql.generated'

import FormattedPrice from 'components/FormattedPrice'

import classNames from 'helpers/css'

import styles from './index.module.scss'

const PriceCalculationList: React.FC<PricaCalculationListProps> = (props) => {
  const { priceCalculationItems } = props

  if (!priceCalculationItems?.length) {
    return null
  }

  return (
    <List
      className={classNames(styles, 'contact-request__overview__content__price-calculation-list')}
      dataSource={priceCalculationItems || []}
      bordered={false}
      renderItem={(item) => (
        <List.Item key={item.name}>
          <div className={classNames(styles, 'contact-request__overview__content__price-calculation-list__item')}>
            <div className={
              classNames(styles, 'contact-request__overview__content__price-calculation-list__item__header')
            }>
              <p>
                {item.name}
                {item.quantity > 1 && ` × ${item.quantity}`}
              </p>

              <p>
                <FormattedPrice price={Number(item.price) * item.quantity} />
              </p>
            </div>
            <p className={
              classNames(styles, 'contact-request__overview__content__price-calculation-list__item__description')
            }>
              {item.description}
            </p>
          </div>
        </List.Item>
      )}
    />
  )
}

type PricaCalculationListProps = {
  priceCalculationItems?: NonNullable<ProviderPriceCalculationQuery['provider']>['priceCalculationItems']
}

export default PriceCalculationList
